import './polyfills';  // 👈 must be first
import './index.css'

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Modal from 'react-modal';


window.Buffer = Buffer;

Modal.setAppElement('#root');

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);

// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

root.render(
  <App />
);
